import React, { useEffect, useState } from 'react';
import { Route, Switch, Redirect, useLocation, useHistory, matchPath } from 'react-router-dom';
import IdleTimer, { useIdleTimer } from 'react-idle-timer';
import {
  Confirm,
  Tab
} from 'semantic-ui-react';

import { Nav, Alert, Banner } from '../_components';
import { Patients } from '../patients';
import { Facilities } from '../facilities';
import { Providers } from '../providers';
import { Metrics } from '../metrics';
import { DesignatedContacts } from '../designated_contacts';
import { Administrators } from '../administrators';
import Login from '../session/Login';
import { Logout } from '../session/Logout';
import useToken from '../session/Token';
import { Session }  from '../session';
import { sessionService, alertService } from '../_services';
import IdleTimerModal from '../_components/IdleTimerModal';
import ConfirmEmail from '../confirmation/ConfirmEmail';
import SetPassword from '../confirmation/SetPassword';
import SelectMFA from '../confirmation/SelectMFA';
import { cookieHelper } from "../_helpers/cookie-helper";

function App() {
    const { pathname } = useLocation();
    const history = useHistory();
    const { token, setToken , getToken} = useToken();
    const [authorized, setAuth] = useState(false);
    const [routes, authorizeRoutes] = useState(<></>);
    const [defaultIndx, setDefault] = useState(0);
    const [tabIndx, setTab] = useState();
    const version = '2.05.000';


    // Idle timer states
    const timeoutMinutes = parseInt(process.env.REACT_APP_SESSION_TIMEOUT);
    const [timeout, setTimeout] = useState(1000 * 30 * timeoutMinutes);   // Using 30 bc we reset the timer once, so we halve the amount of time we want the timeout/logout to be
    const [showModal, setShowModal] = useState(false);
    const [isTimedOut, setIsTimedOut] = useState(false);
    const [idleTimer, setIdleTimer] = useState();


    let panes = []
    let role = sessionStorage.getItem("user_role");
    let url = window.location.href;
    let segments = url.split('/');


    useEffect(()=>{
      authorizeRoutes(getRoutes);
    }, [token, pathname])

    const getRoutes = () => {
      const userRole = sessionStorage.getItem('user_role');
      const path = pathname.split('/')[1];
      setToken(getToken());
      if(!!token && !['ConfirmEmail', 'SelectMFA', 'SetPassword'].includes(path)){
        if(userRole == 'Es_administrator' || userRole == 'Es_customer_service' || userRole == 'Field_rep'){
          setAuth(true);
          return authorizedRoutes;
        }
      }else{
        setAuth(false);
        return unauthorizedRoutes;
      }
      setAuth(false);
      return unauthorizedRoutes;
    }

    //Paths when the token is set and confirmed ES_ADMIN or ES_CUSTOMER_SERVICE
    const authorizedRoutes = (
      <Switch>
        <Route exact path='/' component={Patients}/>
        <Route path="/patients" component={Patients} />
        <Route path="/providers" component={Providers} />
        <Route path="/designated_contacts" component={DesignatedContacts} />
        <Route path="/facilities" component={Facilities} />
        <Route path="/metrics" component={Metrics} />
        <Route path="/administrators" component={Administrators} />
        <Route path={matchPath.path} component={Patients}/>
      </Switch>
    );

    //Paths when the auth token it not set yet
    const unauthorizedRoutes = (
      <Switch>
          <Route exact path='/' component={Login}/>
          <Route path='/ConfirmEmail/*' exact component={ConfirmEmail}/>
          <Route path='/SetPassword' exact component={SetPassword}/>
          <Route path='/SelectMFA' exact component={SelectMFA}/>
          <Route path='/request' component={Login}/>
          <Route path={matchPath.path} component={Login}/>
      </Switch>
    );

    // Idle timer functions
    const handleClose = async () =>  {
      setShowModal(false);
      let success = await sessionService.refresh();
      if (!success){
        cookieHelper.deleteCookie("access_token");
        setToken("");
        history.push("/login");
        alertService.info('Session timed out.');
        return;
      }
    }
    const handleLogout = (fromTimeout = false) =>  {
      setAuth(false);
      setShowModal(false);
      setIsTimedOut(false);
      if(!fromTimeout){
        sessionService
        .delete()
        .then(() => {
          setToken("");
          history.push("/login")
        }).catch(() => {
          setToken("");
          alertService.error;
        });
      }else{
        cookieHelper.deleteCookie("access_token");
        setToken("");
        history.push("/login");
        alertService.info('Session timed out.');
      }
      
    }

    const onAction = (e) => {
      setIsTimedOut(false);
    }

    const onActive = () => {
      setIsTimedOut(false);
    }

    const onIdle = async () => {
      if (isTimedOut) {
        handleLogout(true);
      } else {
        let success = await sessionService.refresh();
        if (!success){
          cookieHelper.deleteCookie("access_token");
          setToken("");
          history.push("/login");
          alertService.info('Session timed out.');
          return;
        }
        setShowModal(true);
        idleTimer.reset();
        setIsTimedOut(true);
      }
    }
    
    const handleTabChange = (event, data) => {
      setTab(data.activeIndex);
    }

    if (role == 'Es_administrator' || role == 'Es_customer_service' ) {
      panes = [
        {
          menuItem: 'Patients',
          render: () => <Redirect from="/:url*(/+)" to="/patients" component={Patients} />
        },
        {
          menuItem: 'Providers',
          render: () => <Redirect from="/:url*(/+)" to="/providers" component={Providers} />
        },
        {
          menuItem: 'Designated Contacts',
          render: () => <Redirect from="/:url*(/+)" to="/designated_contacts" component={DesignatedContacts} />
        },
        {
          menuItem: 'Facilities',
          render: () => <Redirect from="/:url*(/+)" to="/facilities" component={Facilities} />
        },
        {
          menuItem: 'Metrics',
          render: () =>  <Redirect from="/:url*(/+)" to="/metrics" component={Metrics} />
        },
        {
          menuItem: 'Administrators',
          render: () =>  <Redirect from="/:url*(/+)" to="/administrators" component={Administrators} />
        }
      ]
    } else if (!!role) {
       panes = [
        {
          menuItem: 'Patients',
          render: () => <Redirect from="/:url*(/+)" to="/patients" component={Patients} />
        },
        {
          menuItem: 'Providers',
          render: () => <Redirect from="/:url*(/+)" to="/providers" component={Providers} />
        },
        {
          menuItem: 'Designated Contacts',
          render: () => <Redirect from="/:url*(/+)" to="/designated_contacts" component={DesignatedContacts} />
        },
        {
          menuItem: 'Facilities',
          render: () => <Redirect from="/:url*(/+)" to="/facilities" component={Facilities} />
        },
      ]
    }else{
      panes = []
    }

    if(!!cookieHelper.getAuthToken() && authorized == false){
      let registering = sessionStorage.getItem('registering');
      if(!registering){
        const userRole = sessionStorage.getItem('user_role');
        if(userRole == 'Es_administrator' || userRole == 'Es_customer_service' || userRole == 'Field_rep'){
          setAuth(true);
          authorizeRoutes(authorizedRoutes);
          return;
        }
      }
    }

    

    return (
      <div className="app-container bg-light">
        {authorized?<Nav />:<Banner/>}
        <Alert />
        {authorized?<>
          <IdleTimerModal
          showModal={showModal}
          handleClose={handleClose}
          handleLogout={handleLogout}
          timeoutInMins={timeoutMinutes}
        />
        <IdleTimer
          ref={ref => setIdleTimer(ref)}
          element={document}
          onActive={onActive}
          onIdle={onIdle}
          onAction={onAction}
          debounce={250}
          timeout={timeout} />
        </>:<></>}
        {authorized?<div className="pl-4 pt-4 pb-4 pr-4">
          <div className="tabbar">
            <Tab menu={{ secondary: true, pointing: true}} defaultActiveIndex={defaultIndx} activeIndex={tabIndx} onTabChange={handleTabChange} panes={panes}/>
          </div>
        </div>: <></>}
        <Switch>
          <Route path="/login" component={Login}/>
          <Route path="/logout" component={Session} />
          {routes}
          <Route>
            <Redirect from="/:url*(/+)" to={pathname.slice(0, -1)} />
          </Route>
          
        </Switch>
      </div>
    );
}

export { App };
